export interface GeoCodingOptions {
  address: string;
}

export const geocoder = (options: GeoCodingOptions): Promise<google.maps.GeocoderResult[] | null> => {
  return new Promise((resolve, reject) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(options, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        resolve(results);
      } else {
        reject(results);
      }
    });
  });
};
